"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsDeleteFingerModal = void 0;
var _DmsModal = require("../../DmsModal/DmsModal");
var _react = _interopRequireWildcard(require("react"));
var _DmsFetch = require("../../DmsFetch/DmsFetch");
var _HttpStatus = require("../../../constants/HttpStatus");
var _DmsButton = require("../../DmsButton/DmsButton");
var _Visibility = _interopRequireDefault(require("@mui/icons-material/Visibility"));
var _FingerprintRounded = _interopRequireDefault(require("@mui/icons-material/FingerprintRounded"));
var _material = require("@mui/material");
var _DmsAltBoxInfo = require("../../DmsAltBoxInfo/DmsAltBoxInfo");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsDeleteFingerModal = _ref => {
  let {
    selectedRowData,
    modalDelete,
    setShowModalDelete,
    token
  } = _ref;
  const [showErrorInfo, setShowErrorInfo] = (0, _react.useState)(false);
  const handleRegisterFinger = async () => {
    const url_device = "finger_printer/device/delete_by_user_id/" + selectedRowData.pk;
    const response = await (0, _DmsFetch.fetchData)(url_device, "DELETE", token);
    if (response.status === _HttpStatus.HTTP_STATUS.OK_200) {
      const url_dms = "finger_printer/dms/delete_by_user_id/" + selectedRowData.pk;
      const response_device = await (0, _DmsFetch.fetchData)(url_dms, "DELETE", token);
      if (response_device.status === _HttpStatus.HTTP_STATUS.CREATED_201) {
        setShowModalDelete(false);
      } else {
        setShowModalDelete(false);
        setShowErrorInfo(true);
      }
    } else {
      setShowModalDelete(false);
      setShowErrorInfo(true);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal, {
    isVisible: modalDelete,
    onClose: () => setShowModalDelete(false),
    closeWithIconOnly: true
  }, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Header, {
    title: "Delete fingers",
    onClose: () => setShowModalDelete(false)
  }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_FingerprintRounded.default, {
    style: {
      fontSize: '4rem',
      color: 'red'
    }
  }))), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Footer, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "center",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "danger",
    text: "Delete Finger",
    onClick: handleRegisterFinger
  })))), showErrorInfo && /*#__PURE__*/_react.default.createElement(_DmsAltBoxInfo.DmsAltBoxInfo.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBoxInfo.DmsAltBoxInfo.Icon, {
    className: "dms_danger",
    Icon: _Visibility.default
  }), /*#__PURE__*/_react.default.createElement(_DmsAltBoxInfo.DmsAltBoxInfo.Content, null, /*#__PURE__*/_react.default.createElement(_DmsAltBoxInfo.DmsAltBoxInfo.Title, {
    title: "Failed to read finger printer"
  }), /*#__PURE__*/_react.default.createElement(_DmsAltBoxInfo.DmsAltBoxInfo.Value, {
    value: "Check the finger printer and try again"
  }))));
};
exports.DmsDeleteFingerModal = DmsDeleteFingerModal;